'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _brandTopHeader = require('../brand-top-header/brand-top-header');

var _brandTopHeader2 = _interopRequireDefault(_brandTopHeader);

var _brandSubHeader = require('../brand-sub-header/brand-sub-header');

var _brandSubHeader2 = _interopRequireDefault(_brandSubHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandOrderHeader = function BrandOrderHeader(_a) {
        var active = _a.active,
            isNotificationActive = _a.isNotificationActive,
            brandIcon = _a.brandIcon,
            showSubHeader = _a.showSubHeader,
            activeSubHeader = _a.activeSubHeader;
        return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_brandTopHeader2.default, { brandIcon: brandIcon || 'https://res.cloudinary.com/ninety-seconds/image/upload/v1607012790/-design-system/huawei-icon.jpg', isNotificationActive: isNotificationActive, active: active }), showSubHeader && _react2.default.createElement(_brandSubHeader2.default, { active: activeSubHeader || 1 }));
};
exports.default = _react2.default.memo(BrandOrderHeader);
//# sourceMappingURL=brand-order-header.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/components/brand-order-header/brand-order-header.js
// module id = 1865
// module chunks = 0